import * as types from "@/store/types";

const state = {
  userInfo: {},
  marketUserInfo: {}
};

const getters = {
  [types.userInfo.getters.GET_USER_INFO]: state => {
    return state.userInfo;
  },
  [types.marketUserInfo.getters.GET_USER_INFO]: state => {
    return state.marketUserInfo;
  }
};

const mutations = {
  [types.userInfo.mutations.MUTATE_USER_INFO]: (state, payload) => {
    state.userInfo = payload;
  },

  [types.userInfo.mutations.MUTATE_GOOGLE_VERIFICATION]: (state, payload) => {
    if (payload === "active") {
      state.userInfo = {
        ...state.userInfo,
        two_factor_auth_method: [
          ...state.userInfo.two_factor_auth_method,
          {
            locale: "احراز هویت با گوگل (Google Authentication)",
            value: "GOOGLE2FA"
          }
        ]
      };
    } else if (payload === "inActive") {
      if (
        state.userInfo.two_factor_auth_method?.some(
          method => method.value === "SMS"
        )
      ) {
        state.userInfo = {
          ...state.userInfo,
          two_factor_auth_method: state.userInfo.two_factor_auth_method.filter(
            method => method.value === "SMS"
          )
        };
      } else {
        state.userInfo = {
          ...state.userInfo,
          two_factor_auth_method: []
        };
      }
    }
  },

  [types.userInfo.mutations.MUTATE_SMS_VERIFICATION]: (state, payload) => {
    if (payload === "active") {
      state.userInfo = {
        ...state.userInfo,
        two_factor_auth_method: [
          ...state.userInfo.two_factor_auth_method,
          {
            locale: "احراز هویت با پیامک (Sms Authentication)",
            value: "SMS"
          }
        ]
      };
    } else if (payload === "inActive") {
      if (
        state.userInfo.two_factor_auth_method?.some(
          method => method.value === "GOOGLE2FA"
        )
      ) {
        state.userInfo = {
          ...state.userInfo,
          two_factor_auth_method: state.userInfo.two_factor_auth_method.filter(
            method => method.value === "GOOGLE2FA"
          )
        };
      } else {
        state.userInfo = {
          ...state.userInfo,
          two_factor_auth_method: []
        };
      }
    }
    state.userInfo = {
      ...state.userInfo,
      two_factor_auth_method: [
        ...state.userInfo.two_factor_auth_method,
        payload
      ]
    };
  },

  [types.userInfo.mutations.MUTATE_USERNAME]: (state, payload) => {
    state.userInfo = {
      ...state.userInfo,
      username: payload
    };
  },

  [types.userInfo.mutations.MUTATE_DEFAULT_STRATEGY]: (state, payload) => {
    state.userInfo = {
      ...state.userInfo,
      two_factor_auth_default: payload
    };
  },

  [types.userInfo.mutations.MUTATE_MOBILE_NUMBER]: (state, payload) => {
    state.userInfo = {
      ...state.userInfo,
      mobile: payload
    };
  },

  [types.userInfo.mutations.MUTATE_PERSONAL]: (state, payload) => {
    state.userInfo = {
      ...state.userInfo,
      name: payload.fullname,
      national_code: payload.national_code,
      birth_date: payload.birth_date
    };
  },

  [types.marketUserInfo.mutations.MUTATE_USER_INFO]: (state, payload) => {
    state.marketUserInfo = payload;
  }
};

const actions = {
  [types.userInfo.actions.ACTION_USER_INFO]: ({ commit }, payload) => {
    commit(types.userInfo.mutations.MUTATE_USER_INFO, payload);
  },

  [types.userInfo.actions.SET_GOOGLE_VERIFICATION]: ({ commit }, payload) => {
    commit(types.userInfo.mutations.MUTATE_GOOGLE_VERIFICATION, payload);
  },

  [types.userInfo.actions.SET_SMS_VERIFICATION]: ({ commit }, payload) => {
    commit(types.userInfo.mutations.MUTATE_SMS_VERIFICATION, payload);
  },

  [types.userInfo.actions.SET_USERNAME]: ({ commit }, payload) => {
    commit(types.userInfo.mutations.MUTATE_USERNAME, payload);
  },

  [types.userInfo.actions.SET_DEFAULT_STRATEGY]: ({ commit }, payload) => {
    commit(types.userInfo.mutations.MUTATE_DEFAULT_STRATEGY, payload);
  },

  [types.userInfo.actions.SET_MOBILE_NUMBER]: ({ commit }, payload) => {
    commit(types.userInfo.mutations.MUTATE_MOBILE_NUMBER, payload);
  },

  [types.userInfo.actions.SET_PERSONAL]: ({ commit }, payload) => {
    commit(types.userInfo.mutations.MUTATE_PERSONAL, payload);
  },
  [types.marketUserInfo.actions.ACTION_USER_INFO]: ({ commit }, payload) => {
    commit(types.marketUserInfo.mutations.MUTATE_USER_INFO, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
